import { ManageRolesTablePropertiesSidePanel } from "PFApp/activities/manage_roles/parts/table_properties/manage_roles_table_properties_side_panel";
import { TablePropertiesButton } from "PFApp/components/table_properties/table_properties_button";
import { useState } from "react";

export const ManageRolesTableProperties = () => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      <TablePropertiesButton
        onClick={() => setIsVisible(true)}
        qaId="BookingModuleWorkforceTablePropertiesButton"
      />
      <ManageRolesTablePropertiesSidePanel isVisible={isVisible} onCloseClick={() => setIsVisible(false)} />
    </>
  );
};
